var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagenation"},[_c('a-pagination',{attrs:{"defaultCurrent":1,"pageSize":_vm.pageSize,"total":_vm.total,"size":_vm.size,"current":_vm.current},on:{"change":_vm.pageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }